enum TaskInterval {
  Second = 1000,
  Minute = 60000,
}

export default TaskInterval
